import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ViewOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.378 11.62c-.1.6-.7.9-1.3.8-1.302-.3-2.702-.5-4.103-.5-4.703 0-9.105 2-12.607 4.3-3.502 2.3-6.103 5-7.204 6.2 1 1.1 3.302 3.5 6.504 5.7.5.3.6 1 .2 1.5-.3.5-1 .6-1.5.3-3.303-2.3-5.804-4.8-6.805-6-.8-.8-.7-2 0-2.8 1.201-1.3 3.903-4.1 7.705-6.6 3.702-2.5 8.504-4.7 13.807-4.7 1.6 0 3.102.2 4.602.5.5.1.801.7.7 1.3ZM43.386 21.02c-1.5-1.6-5.202-5.4-10.305-8.2l6.603-6.6c.4-.4.4-1.1 0-1.5-.4-.4-1.1-.4-1.5 0L4.265 38.62c-.4.4-.4 1.1 0 1.5.4.4 1.101.4 1.501 0l7.104-7.1c2.802 1.2 5.803 2.1 9.105 2.1 5.303 0 10.105-2.2 13.807-4.7s6.504-5.3 7.705-6.5c.7-.9.7-2.1-.1-2.9Zm-16.809-1.7c.6.9 1.001 2 1.001 3.1 0 3-2.501 5.5-5.503 5.5-1.2 0-2.201-.4-3.102-1l7.605-7.6Zm15.309 3.1c-1.1 1.2-3.702 3.9-7.304 6.2-3.502 2.3-7.905 4.3-12.607 4.3-2.601 0-5.203-.6-7.504-1.6l2.901-2.9c1.301 1 2.902 1.5 4.603 1.5 4.202 0 7.604-3.4 7.604-7.6 0-1.7-.6-3.3-1.6-4.6l3.501-3.5c5.103 2.7 9.005 6.6 10.406 8.2Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.975 16.92a5.485 5.485 0 0 0-5.503 5.5c0 .6-.5 1-1 1-.6 0-1.001-.5-1.001-1 0-4.2 3.402-7.6 7.604-7.6h.7c.6 0 1.001.5 1.001 1.1 0 .6-.5 1-1.1 1h-.701Z"
  }));
});
ViewOff.displayName = 'ViewOff';
ViewOff.defaultProps = {
  'aria-label': 'ViewOff'
};
export default ViewOff;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ViewOff.js
// module id = 3949
// module chunks = 11